/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;
				}

				this.classList.add('product-recommendations--loaded');
				this.setupEvents();

				setTimeout(() => {
					window.dispatchEvent(new Event('resize'));

					ScrollTrigger.batch('.animations-true .product-card .product-featured-image-link', {
						start: "top 90%",
						onEnter: (elements, triggers) => {
							gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
						}
					});
				});
			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
	}
	setupEvents() {
		this.cleanupCarousel?.();
		const track = this.querySelector('[data-recommendations-track]');
		if (track) {
			this.setupCarousel(track);
			return;
		}
		this.slideshow = Flickity.data(this.querySelector('slide-show'));
		this.prev = this.querySelector('.flickity-prev');
		this.next = this.querySelector('.flickity-next');

		const events = new AbortController();
		for (const [control, direction, label] of [[this.prev, 'prev', 'Previous product'], [this.next, 'next', 'Next product']]) {
			if (!control) continue;
			control.setAttribute('role', 'button');
			if (!control.hasAttribute('aria-label')) control.setAttribute('aria-label', label);
			control.addEventListener('click', () => this.navClick(direction), { signal: events.signal });
			if (control.tagName !== 'BUTTON') {
				control.addEventListener('keydown', (event) => {
					if (event.key !== 'Enter' && event.key !== ' ') return;
					event.preventDefault();
					if (!event.repeat) control.click();
				}, { signal: events.signal });
			}
		}
		this.cleanupCarousel = () => events.abort();
	}
	setupCarousel(track) {
		const prev = this.querySelector('[data-recommendations-prev]');
		const next = this.querySelector('[data-recommendations-next]');
		const update = () => {
			const max = track.scrollWidth - track.clientWidth;
			const position = Math.abs(track.scrollLeft);
			prev.hidden = next.hidden = max <= 1;
			prev.disabled = position <= 1;
			next.disabled = position >= max - 1;
		};
		const move = direction => {
			const rtl = getComputedStyle(track).direction === 'rtl';
			track.scrollBy({
				left: direction * track.clientWidth * (rtl ? -1 : 1),
				behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
			});
		};
		const previousPage = () => move(-1);
		const nextPage = () => move(1);
		prev.addEventListener('click', previousPage);
		next.addEventListener('click', nextPage);
		track.addEventListener('scroll', update, { passive: true });
		const observer = new ResizeObserver(update);
		observer.observe(track);
		this.cleanupCarousel = () => {
			observer.disconnect();
			prev.removeEventListener('click', previousPage);
			next.removeEventListener('click', nextPage);
			track.removeEventListener('scroll', update);
		};
		update();
	}
	disconnectedCallback() {
		this.cleanupCarousel?.();
	}
	navClick(direction) {
		if (!this.slideshow) return;
		if (direction == 'prev') {
			this.slideshow.previous();
		} else {
			this.slideshow.next();
		}
	}

}

customElements.define('product-recommendations', ProductRecommendations);
